import { render, staticRenderFns } from "./dialogStatusConfig.vue?vue&type=template&id=d19e14b2"
import script from "./dialogStatusConfig.vue?vue&type=script&lang=js"
export * from "./dialogStatusConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports